import { useStore } from 'components/Store';
import featureFlagRenderItem from 'helpers/featureFlagRenderItem';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { InvoiceFlagsResult } from '../types';

const useInvoiceFlags = (): InvoiceFlagsResult => {
  const {
    feInvoicesV2EnableModule,
    feInvoicesV2EnableModuleByOrg
  } = useFlags();

  const { state } = useStore();
  const { id } = state?.organization || {};

  const feInvoicesActive = featureFlagRenderItem(
    feInvoicesV2EnableModule,
    feInvoicesV2EnableModuleByOrg,
    id
  );

  return { feInvoicesActive };
};

export default useInvoiceFlags;
